module.exports = __webpack_public_path__ + "static/media/32.401242ef.jpg";